import React from 'react';
import {ReactComponent as LabTechnician} from '../../../assets/images/lab-technician-1.svg';
import {ReactComponent as Prescription} from '../../../assets/images/prescription-1.svg';
import {ReactComponent as HomeCollection} from '../../../assets/images/address-location-1.svg';
import {ReactComponent as Hospital} from '../../../assets/images/hospital-1.svg';

export const TEST_OPTIONS = [
    {
        label: 'Select Test By Own',
        name: 'Test By Own',
        inputName: 'testType',
        svgImage: <LabTechnician />,
        value: 0
    },
    {
        label: 'Request By Prescription',
        name: 'Test By Prescription',
        inputName: 'testType',
        svgImage: <Prescription />,
        value: 1
    }
];

export const TEST_COLLECTIONS = [
    {
        label: 'Home Collection',
        name: 'Home Collection',
        inputName: 'collectionType',
        svgImage: <HomeCollection />,
        value: 0
    },
    {
        label: 'Center Visit',
        name: 'Center Visit',
        inputName: 'collectionType',
        svgImage: <Hospital />,
        value: 1
    }
];

export const TEST_TYPES = ['by_own', 'by_prescription'];